import {Defined} from './essentials'

export class Option<T> {
  public static from<U>(val: U): Option<U> {
    return new Option(val)
  }

  private value: T | undefined

  private constructor(value: T | undefined) {
    this.value = value
  }

  public map<U>(cb: (val: T) => U): Option<U> {
    if (this.isEmpty() || this.value === undefined) {
      return new Option<U>(undefined)
    } else {
      return new Option(cb(this.value))
    }
  }

  public get(): T | undefined {
    return this.value
  }

  public getOr(fallbackFn: () => T): T {
    if (this.isEmpty() || this.value === undefined) {
      return fallbackFn()
    }
    return this.value
  }

  public getOrElse(defaultValue: Defined<T>): Defined<T> {
    if (this.isEmpty() || this.value === undefined) {
      return defaultValue
    }
    return this.value as Defined<T>
  }

  public apply(fn: (val: T) => void): Option<T> {
    if (!this.isEmpty() && this.value !== undefined) {
      fn(this.value)
    }
    return this
  }

  public ifEmpty(fn: () => void): Option<T> {
    if (this.isEmpty()) {
      fn()
    }
    return this
  }

  public isEmpty(): boolean {
    return (
      this.value === null ||
      (!this.value &&
        (this.value as unknown) !== 0 &&
        (this.value as unknown) !== false &&
        (this.value as unknown) !== '')
    )
  }
}
